import { cn } from "@-/com.npmjs.cn";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useActorToneColors } from "@-/dev.improve.haniverse.routes.nav.app._lib.actor.user";
import { toneForPinyin } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.transcription";
import { styled } from "styled-components/native";

const PlaceGlyph = styled(Text)<{ $color: string }>`
  color: ${({ $color }) => $color};
`;

/**
 * One character of a place's name in its place-name pronunciation's tone color, whether learned or
 * locked: semibold once learned, regular while locked.
 */
export function ChinaMapPlaceGlyph({
  className,
  glyph,
  pinyin,
  studied,
}: {
  className?: string;
  glyph: string;
  /** The character's tone-number reading in the place's name (`ChinaMapPlace.pinyin`). */
  pinyin: string;
  studied: boolean;
}) {
  const toneColors = useActorToneColors();
  const tone = toneForPinyin(pinyin);
  return (
    <PlaceGlyph
      $color={tone === null ? "#000000" : toneColors[tone]}
      className={cn(studied ? "font-semibold" : "font-normal", className)}
    >
      {glyph}
    </PlaceGlyph>
  );
}
